module.exports = __webpack_public_path__ + "static/media/mattermost_logo.ae093764.svg";